import { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Hook to check if a page is publicly visible
 * If the page is invisible, it will no longer redirect away.
 * @param {string} pageKey - The page visibility key (e.g., 'proposer')
 */
export const usePageVisibility = (pageKey) => {
  useEffect(() => {
    const checkPageVisibility = async () => {
      try {
        const res = await axios.get(`${API}/pages/status`);
        if (!res.data[pageKey]) {
          toast.error('Cette page est actuellement désactivée. Vous pouvez rester sur cette page.');
        }
      } catch (error) {
        console.error('Erreur lors de la vérification de disponibilité:', error);
      }
    };

    checkPageVisibility();
  }, [pageKey]);
};
